import type { DealBadge } from "@/components/ProductCard"
import i18n from "@/i18n/config"
import type { Price } from "@/queries/models"

export const getDealBadge = (price?: Price): DealBadge | undefined => {
  if (!price) return undefined

  const discountExtraPoints = price.discountExtraPoints

  if (discountExtraPoints) {
    return {
      text: "Member deal - " + discountExtraPoints.text,
      isMemberDeal: true,
    }
  }

  const discountedPrice = price.discountedPrice
  if (!discountedPrice) return undefined

  return discountedPrice.isMyDeal
    ? {
        text: "Member deal!",
        isMemberDeal: true,
      }
    : discountedPrice.percent > 0
      ? {
          text: `${i18n.t("discountSavingsLabel")} ${discountedPrice.percent}%!`,
          isMemberDeal: false,
        }
      : undefined
}
